// when changes are made, copy over to server: const_share_copy
const shared = {
  // status
  status: {
    APPROVED: 'Approved',
    UNTESTED: 'Untested',
    QCONLY: 'QC Only',
    PENDING: 'Pending Approval',
    CANCELLED: 'CANCELLED',
  },

  unit: {
    Bags: 'Bags',
    Cups: 'Cups',
    Drums: 'Drums',
    Gal: 'Gal',
    Grams: 'Grams',
    Lbs: 'Lbs',
    Ounces: 'Ounces',
    Spoons: 'Spoons',
    Totes: 'Totes',
  },
};

export default shared;
